module.exports = new __parcel__URL__("dark.90199792.svg").toString();